import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { Query } from '../../../__generated__/pge-types';
import { getAccountPlannedOutageEvents } from '../../../queries/outage.query';
import { useErrorNotification } from '../components/common/error-notification';
import { useEffect } from 'react';

export const useGetAccountPlannedOutageEvents = (
  accountNumber: string | undefined,
) => {
  const { data, error, loading, refetch } = useQuery<Query>(
    getAccountPlannedOutageEvents,
    {
      variables: {
        input: {
          accountNumber: accountNumber,
        },
      },
      skip: !accountNumber,
    },
  );

  const { setErrorNotification } = useErrorNotification();

  useEffect(() => {
    error && setErrorNotification();
  }, [error]);

  return {
    plannedOutageData: data?.getAccountPlannedOutageEvents,
    error,
    loading,
    refetch,
  };
};
